// Matches item-database-layer split_csv_param. A trailing separator tells the
// count APIs to keep commas that belong inside a topic or keyword label.
const FILTER_LIST_SEPARATOR = "\u001f";

export function countFilterQuery(input: object): string {
  const params = new URLSearchParams();
  Object.entries(input).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      if (value.length === 0) return;
      params.append(
        key,
        `${value.map(String).join(FILTER_LIST_SEPARATOR)}${FILTER_LIST_SEPARATOR}`
      );
      return;
    }
    if (value === undefined || value === null || value === "") return;
    params.append(key, String(value));
  });
  return params.toString();
}
